import Table from 'rc-table'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { SoldProducts } from '../../../../api/api'
import Loading from '../../../Loading'
import SubjectTypeFilterSelect from '../../../reports/SubjectTypeFilterSelect'
import { buildSoldTableData } from '../../../../services/soldReportHelper'
import {
  SUBJECT_TYPE_FILTER_ALL,
  parseSubjectTypeFilter,
} from '../../../../services/reportFilterHelper'

const columns = [
  { title: '', dataIndex: 'name', key: 'name', width: 100 },
  { title: 'امروز', dataIndex: 'today', key: 'today', width: 100 },
  { title: 'دیروز', dataIndex: 'yesterday', key: 'yesterday', width: 100 },
  { title: 'هفته', dataIndex: 'week', key: 'week', width: 100 },
  { title: 'ماه', dataIndex: 'months', key: 'months', width: 100 },
  { title: 'کل', dataIndex: 'total', key: 'total', width: 100 },
]

export default function SoldsDataTable({ SubjectId = null, title = '' }) {
  const [isLoading, setIsLoading] = useState(false)
  const [soldTableData, setSoldTableData] = useState([])
  const [subjectTypeFilter, setSubjectTypeFilter] = useState(SUBJECT_TYPE_FILTER_ALL)

  useEffect(() => {
    const getSoldReport = async () => {
      try {
        setIsLoading(true)
        const typeParam = parseSubjectTypeFilter(subjectTypeFilter)
        const res = await axios.get(SoldProducts(SubjectId, typeParam))
        setSoldTableData(buildSoldTableData(res.data))
      } catch {
        setSoldTableData(buildSoldTableData(null))
      } finally {
        setIsLoading(false)
      }
    }

    getSoldReport()
  }, [SubjectId, subjectTypeFilter])

  const handleChangeSubjectType = (event) => {
    setSubjectTypeFilter(event.target.value)
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="box_radios">
          <div className="headHolder bordered">
            <p className="title">
              آمار تک فروشی
              {title && <small> ({title}) </small>}
            </p>

            <SubjectTypeFilterSelect
              value={subjectTypeFilter}
              onChange={handleChangeSubjectType}
            />
          </div>

          <div className="chartHolder">
            {isLoading ? (
              <Loading styles="mini" />
            ) : (
              <Table columns={columns} data={soldTableData} tableLayout="auto" />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
